import { COLUMN_WIDTHS } from "./ApplicationConstants";

export const WORK_VIEW_ITEM_TABLE_COL = [
  {
    key: "MMID",
    value: "MMID",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: COLUMN_WIDTHS.lsmall,
  },
  {
    key: "Item Description",
    value: "itemDescription",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: "240px",
  },
  {
    key: "Type",
    value: "displayType",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: COLUMN_WIDTHS.lsmall,
  },
  {
    key: "Contract Item",
    value: "contractItem",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: "405px",
  },
  {
    key: "Quantity",
    value: "quantity",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: "100px",
  },
];

export const WORK_TICKET_AUTOMATION_VIEW_ITEM_TABLE_COL = [
  {
    key: "MMID",
    value: "MMID",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: COLUMN_WIDTHS.xsmall,
  },
  {
    key: "Item Description",
    value: "itemDescription",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: COLUMN_WIDTHS.large,
  },
  {
    key: "Quantity",
    value: "quantity",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: COLUMN_WIDTHS.xsmall,
  },
  {
    key: "Type",
    value: "displayType",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: COLUMN_WIDTHS.large,
  },
  {
    key: "Bundle ID",
    value: "bundleId",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: COLUMN_WIDTHS.xsmall,
  },
];

export const WORK_TICKET_HISTORY_VIEW_ITEM_TABLE_COL = [
  {
    key: "Hardware ID",
    value: "MMID",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: "100px",
  },
  {
    key: "Hardware Name",
    value: "itemDescription",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: COLUMN_WIDTHS.small,
  },
  {
    key: "Category",
    value: "categorySubcategory",
    isFilterEnabled: false,
    filterType: "String",
    isType: true,
    width: "100px",
  },
  {
    key: "Qty",
    value: "quantity",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: "35px",
  },
  {
    key: "ATP Qty",
    value: "atpQuantity",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: "40px",
  },
  {
    key: "ATP Date",
    value: "atpDate",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: "90px",
  },
  {
    key: "Sales Order",
    value: "salesOrder",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: "95px",
  },
  {
    key: "SO Rejected",
    value: "soRejected",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: "80px",
  },
  {
    key: "Line ID",
    value: "lineId",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: "80px",
  },
  {
    key: "Delivery Block",
    value: "deliveryBlock",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    isTooltip: true,
    width: COLUMN_WIDTHS.xsmall,
  },
  {
    key: "Block Description",
    value: "deliveryBlockDescription",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    isEllipsis: true,
    width: COLUMN_WIDTHS.xsmall,
  },
  {
    key: "PGI Date",
    value: "pgiDate",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: "80px",
  },
  {
    key: "PGI Qty",
    value: "pgiQty",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: "80px",
  },
  {
    key: "ERP Type",
    value: "erpType",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: "80px",
  },
];

export const WORK_TICKET_HISTORY_VIEW_ITEM_EXPAND_TABLE_COL = [
  {
    key: "Bundle ID",
    value: "bundleId",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: COLUMN_WIDTHS.xsmall,
  },
  {
    key: "Subscription",
    value: "subscription",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: COLUMN_WIDTHS.xsmall,
  },
  {
    key: "Tech Ref Id",
    value: "techRefId",
    filterType: "String",
    isFilterEnabled: false,
    isSortable: false,
    width: COLUMN_WIDTHS.small,
  },
  {
    key: "ESN",
    value: "esn",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: "90px",
  },
  {
    key: "ESN State",
    value: "esnState",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: "90px",
  },
  {
    key: "Tracking Number",
    value: "trackingNumber",
    filterType: "String",
    isFilterEnabled: false,
    isSortable: false,
    width: "80px",
  },
  {
    key: "Tracking Status",
    value: "trackingStatus",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: COLUMN_WIDTHS.xsmall,
  },
  {
    key: "Delivery Date",
    value: "deliveryDate",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: "80px",
  },
  {
    key: "Delivery Number",
    value: "deliveryNumber",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: COLUMN_WIDTHS.xsmall,
  },
  {
    key: "Return",
    value: "return",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: true,
    ellipsis: false,
    width: COLUMN_WIDTHS.xsmall,
  },
  {
    key: "Return Status",
    value: "referenceWtStatus",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: "80px",
  },
  {
    key: "Return Status Date",
    value: "referenceWtStatusDate",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: COLUMN_WIDTHS.xsmall,
  },
  {
    key: "Unexpected",
    value: "unexpected",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: COLUMN_WIDTHS.xsmall,
  },
];

const REFERENCE_WORK_TICKET_COLUMN = {
  key: "Reference Work Ticket",
  value: "referenceWt",
  isFilterEnabled: false,
  isCustomFilter: false,
  isSortable: false,
  isHyperLink: true,
  ellipsis: false,
  width: COLUMN_WIDTHS.xsmall,
};

// Function to get columns based on ticket type
export const getWorkTicketHistoryViewItemExpandTableCol = (ticketType) => {
  const columns = [...WORK_TICKET_HISTORY_VIEW_ITEM_EXPAND_TABLE_COL];
  if (ticketType && ticketType.toLowerCase() === "return") {
    const esnStateIndex = columns.findIndex((col) => col.value === "esn");
    if (esnStateIndex !== -1) {
      columns.splice(esnStateIndex + 1, 0, REFERENCE_WORK_TICKET_COLUMN);
    }
  }
  return columns;
};
